import { render, staticRenderFns } from "./WebsiteDnsPanel.vue?vue&type=template&id=897d792a&"
import script from "./WebsiteDnsPanel.vue?vue&type=script&lang=ts&"
export * from "./WebsiteDnsPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports